import { render } from "./stallVipStatistics.vue?vue&type=template&id=5ed72213"
import script from "./stallVipStatistics.vue?vue&type=script&lang=js"
export * from "./stallVipStatistics.vue?vue&type=script&lang=js"

import "./stallVipStatistics.vue?vue&type=style&index=0&id=5ed72213&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__